import { FC, ReactNode } from 'react';

interface ConditionalProps {
  condition: boolean;
  children: ReactNode;
}

export const Conditional: FC<ConditionalProps> = ({ condition, children }) => {
  return condition ? <>{children}</> : null;
};
